import styled from 'styled-components';
import { spacing } from '../../../styles/newThemeVariables.styles';
import { TextStyles } from '../../shared/TextBlock.styles';
import { breakpointUp } from '../../../styles/mediaUtils';

export const Block = styled('div')``;

export const Container = styled('div')`
  ${Block} {
    margin-bottom: ${spacing.space72};
  }

  ${Block}:last-child {
    margin-bottom: 0;
  }
`;

export const TextStylesBock = styled('div')`
  grid-column: 1 / -1;

  @media ${breakpointUp.desktop} {
    grid-column: 4 / span 6;
    margin-right: ${spacing.space48};
    max-width: 524px;
  }

  ${TextStyles}
`;
